import getFromCdn from '@anm/helpers/getFromCdn';
import { grayToBlackFilter } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import {
  getFadeInAnimation,
  getFadeOutAnimation
} from './../../styles/helpers';

type WrapperProps = {
  isHovered: boolean;
};

type ItemWrapperProps = {
  isSelected: boolean;
  iconSrc: string;
};

const FADE_ANIMATION_DURATION = 0.3;

export const Wrapper = styled.div<WrapperProps>`
  position: absolute;
  top: 30px;
  right: 30px;
  z-index: 1;
  background: #fff;
  box-shadow: 0px 2px 10px rgba(1, 83, 130, 0.1);
  border-radius: 5px;
  padding: 13px 18px 13px 12px;
  ${({ isHovered }) =>
    isHovered
      ? getFadeInAnimation(FADE_ANIMATION_DURATION)
      : getFadeOutAnimation(FADE_ANIMATION_DURATION)}
`;

export const ListWrapper = styled.ul`
  display: flex;
  align-items: center;
`;

export const ItemWrapper = styled.li<ItemWrapperProps>`
  cursor: pointer;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-right: 18px;
  }

  color: ${({ isSelected }) => (isSelected ? '#292a2b' : '#919eaa')};

  ${({ iconSrc, isSelected }) =>
    iconSrc &&
    css`
      &:before {
        display: block;
        content: '';
        width: 24px;
        height: 24px;
        margin-right: 8px;
        background: url(${getFromCdn(`${iconSrc}`)}) no-repeat center;
        ${isSelected && grayToBlackFilter}
      }
    `}
`;

export const Item = styled.div`
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
`;
